import { CSSValue } from '../interfaces/css-value.type';

export const defaultRoundedButtonBorderRadius: CSSValue = {
	value: 9999,
	unit: 'px',
};
